<div class="content">
  <div class="description subtitle">
    {{ panelSubtitle | translate }}
  </div>
  <div class="control-container">
    <ng-container *ngIf="filteredFieldSchemas$ | async as fieldSchemas; else loading">
      <glxy-form-field required="true">
        <glxy-label>{{ 'AUTOMATIONS.EDITOR.TASKS.MODIFY_CUSTOM_FIELD_DATA.SELECT_FIELD' | translate }}</glxy-label>
        <input type="text" matInput [formControl]="fieldSearch" [matAutocomplete]="auto" />
        <mat-autocomplete
          required
          #auto="matAutocomplete"
          [displayWith]="fieldName"
          ngDefaultControl
          (optionSelected)="onFieldSelected($event)"
        >
          <mat-option *ngFor="let field of fieldSchemas" [value]="field">
            {{ field.fieldName }}
          </mat-option>
        </mat-autocomplete>
        <glxy-error *ngIf="selectedField?.hasError('required') && selectedField.dirty">
          {{ 'AUTOMATIONS.EDITOR.ERRORS.REQUIRED' | translate }}
        </glxy-error>
        <glxy-error *ngIf="selectedField?.hasError('archivedField')">
          {{
            'AUTOMATIONS.EDITOR.TASKS.MODIFY_CUSTOM_FIELD_DATA.ARCHIVED_FIELD_ERROR'
              | translate: { fieldName: selectedField.value?.fieldName }
          }}
        </glxy-error>
      </glxy-form-field>
      <ng-container *ngIf="selectedFieldSchema$ | async as selectedFieldSchema">
        <glxy-form-field>
          <glxy-label>
            {{ 'AUTOMATIONS.EDITOR.TASKS.MODIFY_CUSTOM_FIELD_DATA.SELECT_OPERATION' | translate }}
          </glxy-label>
          <mat-select [formControl]="selectedOperation" [disableOptionCentering]="true" ngDefaultControl>
            <mat-option
              *ngFor="let operation of CustomFieldOperations | operationFilter: selectedFieldSchema"
              [value]="operation.value"
            >
              {{ operation.name | translate }}
            </mat-option>
          </mat-select>
          <glxy-error *ngIf="selectedOperation.hasError('required') && selectedOperation.dirty">
            {{ 'AUTOMATIONS.EDITOR.ERRORS.REQUIRED' | translate }}
          </glxy-error>
        </glxy-form-field>
      </ng-container>
      <ng-container *ngIf="selectedOperation.value && selectedOperation.value !== 'CLEAR_VALUE'">
        <aux-renderer-selector
          #valueField
          *ngIf="selectedFieldHandler$ | async as fieldHandler"
          [handler]="fieldHandler"
        ></aux-renderer-selector>
      </ng-container>
    </ng-container>
    <ng-template #loading>
      <div class="side-drawer-shimmer-container">
        <span class="selector stencil-shimmer"></span>
        <span class="selector stencil-shimmer"></span>
      </div>
    </ng-template>
  </div>
</div>
